<template>
  <div>
    <set-nav-bar :typeId="typeId" :step="step"></set-nav-bar>
    <div class="page-content">
      <div v-if="isShowDefault == false">
        <div class="package_tips">
          <span class="package_tips_text">注：</span>
          {{ hosSetsDesc }}
        </div>
        <div
          class="package"
          v-for="(item, index) in selectedArr"
          :key="'package' + index"
          
        >
          <div class="package-title">
            <div class="package-title_left">
              <div class="package-name">{{ item.itemName }}</div>
              <div
                class="detail-view"
                @click="onDetail(item, index)"
                v-if="item.itemMem != null || item.hosPrintItems != null"
              >
                <img class="detail-img" src="../assets/light.svg" />
                <span class="detail-text">详情</span>
                <div style="margin-top: 2px"></div>
              </div>
              <div class="detial-text"></div>
            </div>
            <div
              class="package_del"
              v-if="isShowDelicon"
              @click="deletePackage(index)"
            >
              <img class="delete-logo" src="../assets/delete.svg" />
              <span class="delete-text">删除</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="select-print">
            <div class="package_content_name">{{ item.itemDesc }}</div>
            <div class="copynum_deal">
              <img
                v-if="isShowCountBtn"
                style="width: 20px; height: 20px"
                @click="subCopyNum(index)"
                src="../assets/sub.png"
              />
              <div class="copynum">{{ item.userSelectCopies }}份</div>
              <img
                v-if="isShowCountBtn"
                style="width: 20px; height: 20px"
                @click="addCopyNum(index)"
                src="../assets/plus.png"
              />
            </div>
          </div>
        </div>
        <div class="package" v-if="isShowOtherNeed == true">
          <div class="package-title" id="otherId">
            <div class="package-title_left">
              <div class="package-name">其他需求</div>
            </div>
            <div class="package_del" @click="deleteOtherList">
              <img class="delete-logo" src="../assets/delete.svg" />
              <span class="delete-text">删除</span>
            </div>
          </div>
          <div
            class="select-print"
            style="background-color: white"
            v-for="(item, index) in cusArr"
            :key="'cusArr' + index"
          >
            <div class="package-content_name">{{ item.itemName }}</div>
            <div class="copynum_deal">
              <div class="copynum">{{ item.userSelectCopies }}份</div>
            </div>
          </div>
        </div>
        <!-- <div class='line'></div> -->
        <div class="radioView" v-if="isShowRadioMr">
          <van-field name="radio" label="病理报告" required>
            <template #input>
              <van-radio-group
                v-model="radio1"
                direction="horizontal"
                v-for="(item, index) in mediaRecords"
                :key="'bingli' + index"
              >
                <van-radio
                  :name="index"
                  @click="clickRadioMr(item)"
                  checked-color="#1aad19"
                  >{{ item.name }}</van-radio
                >
              </van-radio-group>
            </template>
          </van-field>
          <div class="van-cell">
            <div class="eg">请您确认就医期间是否做过病理检查</div>
          </div>
        </div>
        <div class="radioView" v-if="isShowRadioWait">
          <van-field name="radio" label="等病理" class="radioView" required>
            <template #input>
              <van-radio-group
                v-model="radio2"
                direction="horizontal"
                v-for="(item, index) in waitRecords"
                :key="'dbingli' + index"
              >
                <van-radio
                  :name="index"
                  checked-color="#1aad19"
                  @click="clickRadioWait(item)"
                  >{{ item.name }}</van-radio
                >
              </van-radio-group>
            </template>
          </van-field>
          <div class="van-cell">
            <div class="eg">
              病理报告等待时间较长，但不影响报销，如果需要请耐心等待！
            </div>
          </div>
        </div>
        <div class="radioView" v-if="hosWsNeedFlag == 1">
          <van-field
            name="radio"
            label="是否属于外伤"
            class="radioView"
            required
          >
            <template #input>
              <van-radio-group v-model="radio3" direction="horizontal">
                <van-radio
                  name="1"
                  checked-color="#1aad19"
                  @click="clickRadioWaiShang(radio3)"
                  >是</van-radio
                >
                <van-radio
                  name="2"
                  checked-color="#1aad19"
                  @click="clickRadioWaiShang(radio3)"
                  >否</van-radio
                >
              </van-radio-group>
            </template>
          </van-field>
          <div class="van-cell">
            <div class="eg">{{ hosWsDesc }}</div>
          </div>
        </div>
        <!-- <div class="invoiceView van-cell" v-if="isShowInvoiceRadio">
          <van-checkbox
            v-model="checked"
            shape="square"
            checked-color="#1aad19"
            >{{ invoiceHint }}</van-checkbox
          >
        </div> -->
        <!-- <div class="va-cell" v-if="isShowInvoiceHint">
          <div class="invoiceText">{{ invoiceHint }}</div>
        </div> -->
      </div>
      <div class="bg_nodefault" @click="selectOtherUse" v-if="isShowDefault">
        <div class="default_v">
          <img class="no_default" src="../assets/no_default.svg" />
          <div class="t_nodefault">
            您没选择任何复印用途，请
            <span class="click_text">点击</span
            >下方打印用途进行选择您要复印的内容
          </div>
        </div>
      </div>
      <div class="select-btn">
        <div class="btn-print1" v-if="isShowitemBtn" @click="selectOtherUse">
          <img class="print-icon" src="../assets/printuse.svg" />
          <div class="print-name">打印用途</div>
        </div>

        <div
          class="btn-print2"
          v-if="isShowOtherNeedBtn"
          @click="intoOtherNeed"
        >
          <img class="print-icon" src="../assets/otherp.svg" />
          <div class="print-name">其他需求</div>
        </div>
      </div>
      <div v-if="isShowDefault == false" style="margin-bottom: 80px;">
        <div class="message" v-if="isShowReqDes != 1">
          <div class="leavemessage">患者留言</div>
          <!-- error -->
          <van-field
            v-model="message"
            rows="2"
            autosize
            
            type="textarea"
            maxlength="100"
            :placeholder="placeholder"
            show-word-limit
          />
        </div>

        <!-- <div class="agreeCheckbox">
          <van-checkbox v-model="agree" shape="square" checked-color="#1aad19"
            >阅读并同意</van-checkbox
          >
          <span class="terms" @click="showTerms">《相关条款》</span>
        </div> -->
      </div>
      <div
        id="about"
        class="overlay"
        v-show="isShowTerms"
        @click="onClosePopup"
      >
        <!--<div class="weui-popup__overlay"></div>-->
        <div class="floatDiv">
          <div v-html="html"></div>
        </div>
      </div>
    </div>
    <!-- picker -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-button
      type="primary"
      size="large"
      :loading="isLoading"
      loading-text="加载中..."
      class="btn-next"
      :disabled="disabledSubmit"
      safe-area-inset-bottom
      @click="submit"
      color="#1aad19"
      >下一步</van-button
    >
    </div>
  <!-- </div> -->
</template>

<script>
import SetNavBar from "../components/SetNavBar.vue";
import Vue from "vue";
import {
  Picker,
  Popup,
  Notify,
  Dialog,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
} from "vant";

Vue.use(Picker);
Vue.use(Popup);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
let hosItem = new Object();
let cusArr = new Array();
let selectedArr = new Array();
let hosChoiceSet = "";
let mSetName, mSetDesc, mSetCopyNum, mSetId, mSetMem;
let hosLimitSetCount = 8;
let isMediaRecord, isWaitRecord;
let sets = [];
let selectUseExpressType;
export default {
  data() {
    return {
      typeId: 2,
      step: 4,
      columns: [],
      showPicker: false,
      isShowDefault: false,
      hosSetsDesc: "",
      selectedArr: [],
      cusArr: [],
      isShowOtherNeed: false,
      isShowOtherNeedBtn: false,
      isShowDelicon: false,
      isShowCountBtn: false,
      isShowPackage: true,
      isShowDetail: false,
      radio1: 0,
      radio2: 0,
      isShowRadioMr: false,
      isShowRadioWait: false,
      hosWsDesc: "",
      radio3: "",
      checked: false,
      agree: false,
      invoiceHint: "",
      isShowInvoiceHint: false,
      isShowInvoiceRadio: false,
      isShowTerms: false,
      message: "",
      placeholder: "",
      hosWsNeedFlag: "",
      isShowReqDes: "",
      wsNeedFlag: "",
      disabledSubmit: false,
      isLoading: false,
       // 埋点
       mdreferrer:'',
      mdreferrer_title:'',
      // qrView:''
      isFirstDay:false,
      isShowitemBtn:true,
      html: '<br><h3 style="text-align: center;">病案通免责声明</h3><br><ol><li class="li-read">一切移动客户端（APP，微信等）用户在下载或是关注公众号，并浏览APP、微信公众号中的相应《相关条款》均被视为已经仔细阅读本条款并完全同意。凡以任何方式登陆本APP、微信公众号，或是使用本病案通软件者，均被视为自愿接受本网站相关声明和用户服务协议的约束。</li><li class="li-read">为完成业务申请，患者用户提供的文字、图片、音视频等资料，均由患者提供，其真实性、准确性和合法性由信息发布人负责。病案通不提供任何保证，并不承担任何法律责任。</li><li class="li-read">病案通所转载的文字、图片、音视频等资料，如果侵犯了第三方的知识产权或其他权利，责任由作者或转载者本人承担，病案通对此不承担责任。</li><li class="li-read">病案通不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由病案通实际控制的任何网页上的内容，病案通不承担任何责任。</li><li class="li-read">病案通注明之服务条款外，其它因不当使用病案通而导致的任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的任何损失，病案通概不负责，亦不承担任何法律责任。</li><li class="li-read">对于因不可抗力或因黑客攻击、通讯线路中断等病案通不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用病案通，病案通不承担任何责任，但将尽力减少因此给用户造成的损失或影响。</li><li class="li-read">本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。</li><li class="li-read">本网站相关声明版权及其修改权、更新权和最终解释权均属病案通项目所有者北京凯华公司所有。</li></ol><br>',
    };
  },
  components: {
    SetNavBar,
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer= from.path;
      if(from.name == '' || from.name == null || from.name ==undefined){
        vm.mdreferrer_title = '无上一页'
      }else{
        vm.mdreferrer_title = from.name
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
  created() {
    // localStorage.removeItem('Type1Arr')
    // localStorage.removeItem('Type2Arr')
    console.log(hosLimitSetCount + "hosLimitSetCount");
    let hosItemStr = localStorage.getItem("HosItem");
    hosItem = JSON.parse(hosItemStr);
    let selectHbsType = hosItem.selectHbsType;
    selectUseExpressType = hosItem.selectUseExpressType;
    let hosSetsDesc = selectHbsType.hosInfo.hosSetsDesc;
    let maxSet = selectHbsType.hosInfo.hosLimitSetCount;
    console.log(maxSet + "maxSet");
    hosChoiceSet = selectHbsType.hosInfo.hosChoiceSet;
    let placeholder = selectHbsType.hosInfo.hosRemarkTip;
    if (maxSet != null && maxSet != undefined && maxSet != "") {
      hosLimitSetCount = maxSet;
    }
    console.log(hosLimitSetCount + "hosLimitSetCount");
    if (placeholder == null || placeholder == undefined || placeholder == "") {
      this.placeholder = "如果您有特殊需求，可以此处进行备注";
    } else {
      this.placeholder = placeholder;
    }

    this.isShowReqDes = selectHbsType.hosInfo.isShowReqDes;

    // hosChoiceSet = 1
    if (hosSetsDesc == null || hosSetsDesc == undefined || hosSetsDesc == "") {
      this.hosSetsDesc = "只提供住院期间已经做过的检查报告。";
    } else {
      this.hosSetsDesc = hosSetsDesc;
    }

    let pathological = selectUseExpressType.pathological;

    if (pathological != "" && pathological != null) {
      // radioSelect(this)
      if (pathological.show == false) {
        this.isShowRadioMr = false;
        this.isShowRadioWait = false;
        isMediaRecord = "X";
        isWaitRecord = "X";
      } else if (pathological.show == true) {
        this.isShowRadioMr = true;
      }
      this.mediaRecords = pathological.mediaRecords;
      this.waitRecords = pathological.waitRecords;
      for (let i in this.mediaRecords) {
        let objMedia = this.mediaRecords[i];
        let def = objMedia.default;
        // let name = objMedia.name;
        let value = objMedia.value;
        if (def) {
          if (value == "Y") {
            isMediaRecord = "Y";
            this.isShowRadioWait = true;
          } else if (value == "N") {
            isMediaRecord = "N";
            isWaitRecord = "X";
            this.isShowRadioWait = false;
          }
          this.radio1 = parseInt(i);
        }
      }
      console.log(this.radio1);
      for (let i in this.waitRecords) {
        let objMedia = this.waitRecords[i];
        let def = objMedia.default;
        // let name = objMedia.name;
        let value = objMedia.value;
        if (def) {
          if (value == "Y") {
            isWaitRecord = "Y";
          } else if (value == "N") {
            isWaitRecord = "N";
          }
          this.radio2 = parseInt(i);
        }
      }
      if (isMediaRecord == "N" || isMediaRecord == "X") {
        isWaitRecord = "X";
      }
    } else {
      isMediaRecord = "X";
      isWaitRecord = "X";
    }
    console.log(isMediaRecord);
    console.log(isWaitRecord);
    console.log(selectUseExpressType);
    let hosWsNeedFlag = selectHbsType.hosInfo.hosWsNeedFlag; //值为1时显示外伤选择项
    let hosWsDesc = selectHbsType.hosInfo.hosWsDesc; //外伤选择描述
    this.hosWsNeedFlag = hosWsNeedFlag;
    this.hosWsDesc = hosWsDesc;
    // let choice = selectUseExpressType.invoice.choice; //发票相关
    // this.invoiceHint = this.$util.normalString(
    //   selectUseExpressType.invoice.hint
    // );
    // if (choice == 3 || choice == 5) {
    //   this.isShowInvoiceRadio = true;
    // }
    // if (selectUseExpressType.invoice.choice == 4) {
    //   this.isShowInvoiceHint = true;
    // }

    let bId = selectUseExpressType.bId;
    let params = {
      hosId: hosItem.hosId,
      userGetPrintType: bId,
    };
    this.getUserGetPrint(params);
  },
  mounted(){
    var everypage = JSON.parse(localStorage.getItem('everypage'))
    var printinformation = everypage.printinformation + 1
    everypage.printinformation = printinformation;
    if(printinformation == 1){
     this.isFirstDay = true
    }else{
      this.isFirstDay=false
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));
    
    console.log(this,'这是mounted')
    var mdreferrer_title =  localStorage.getItem('title')
    if(mdreferrer_title == '' ||mdreferrer_title == undefined ||mdreferrer_title ==null){
      // mdreferrer = '没有上一页'
      mdreferrer_title = '没有上一页'
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title",mdreferrer_title)
    localStorage.setItem("title",title)
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = 'MPViewScreen'
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(title,url,url_path,is_first_Day,preview,mdreferrer_title)
  },
  methods: {
    // 获取行为日志
    getApplyLog(params) {
      this.$server.getApplyLog(params).then((res) => {
        if (res.result == 1) {
          console.log("获取log成功____________________________");
        }
      });
    },
    onConfirm(value, index) {
      this.showPicker = false;

      let setId = sets[index].setId;
      let setName = sets[index].setName;
      let setDesc = sets[index].setDesc;
      let setMem = sets[index].setMem;
      onSelectMrInfo(this, setId, setName, setDesc, setMem);
    },
    onCancel() {
      // Toast('取消');
      console.log("取消");
    },
    selectOtherUse() {
      this.showPicker = true;
    },

    getUserGetPrint(params) {
      let jsonStr = localStorage.getItem("Type2Arr");
      console.log(jsonStr);
      if (jsonStr == null || jsonStr == "" || jsonStr == "[]") {
        cusArr = new Array();
        this.isShowOtherNeed = false;
        console.log(this.isShowOtherNeed);
        console.log("this.isShowOtherNeed");
      } else {
        cusArr = JSON.parse(jsonStr);
        // this.isShowOtherNeed = true;++++++++++++++++++++
        this.isShowOtherNeed = true;
        this.isShowOtherNeedBtn = true;
        this.isShowDefault = false;
      }
      this.$server.getUserGetPrint(params).then((res) => {
        console.log(res);
        if (res.result == 1) {
          this.columns = res.sets.map((x) => {
            return x.setName;
          });
          sets = res.sets;
          let printItem = res.printItem;
          console.log(sets, printItem);
          if (res.printItem == null || res.printItem == "") {
            this.isShowOtherNeedBtn = false;
          } else {
            this.isShowOtherNeedBtn = true;
          }
          if (sets.length > 0) {
            let type1Arr = localStorage.getItem("Type1Arr");
            console.log(type1Arr);
            if (type1Arr == null || type1Arr == "") {
              selectedArr = new Array();
            } else {
              selectedArr = JSON.parse(type1Arr);
              console.log(selectedArr, JSON.parse(type1Arr));
            }
            switch (hosChoiceSet) {
              case 0:
              case "":
              case null:
                this.isShowDefault = false;
                this.isShowDelicon = true;
                this.isShowCountBtn = true;
                mSetName = sets[0].setName;
                mSetDesc = sets[0].setDesc;
                mSetCopyNum = 1;
                mSetId = sets[0].setId;
                mSetMem = sets[0].setMem;
                var obj = create_item(
                  1,
                  mSetId,
                  mSetName,
                  mSetDesc,
                  mSetCopyNum,
                  mSetMem
                );
                // var type1Arr = localStorage.getItem("Type1Arr");
                var jsonStr1 = localStorage.getItem("Type1Arr");
                var jsonStr2 = localStorage.getItem("Type2Arr");
                if (jsonStr1 == null && jsonStr2 == null) {
                  selectedArr.push(obj);
                }
                break;
              case 1:
                if (this.selectedArr.length <= 0 && cusArr.length <= 0) {
                  this.isShowDefault = true;
                  this.isShowDelicon = true;
                  this.isShowCountBtn = true;
                }
                break;
              case 2:
                this.isShowDefault = false;
                this.isShowDelicon = false;
                this.isShowCountBtn = true;
                this.isShowitemBtn = false;
                // for (let i in res.sets) {
                for (let i = 0; i < res.sets.length; i++) {
                  mSetName = res.sets[i].setName;
                  mSetDesc = res.sets[i].setDesc;
                  mSetCopyNum = 0;
                  mSetId = res.sets[i].setId;
                  mSetMem = res.sets[i].setMem;
                  var obj2 = create_item(
                    1,
                    mSetId,
                    mSetName,
                    mSetDesc,
                    mSetCopyNum,
                    mSetMem
                  );
                  // var type1Arr = localStorage.getItem("Type1Arr");
                  var str1 = localStorage.getItem("Type1Arr");
                  var str2 = localStorage.getItem("Type2Arr");
                  if (str1 == null && str2 == null) {
                    selectedArr.push(obj2);
                  }
                }
                break;
              case 3:
              case 4:
                this.isShowDefault = false;
                this.isShowDelicon = true;
                this.isShowCountBtn = false;
                mSetName = res.sets[0].setName;
                mSetDesc = res.sets[0].setDesc;
                mSetCopyNum = 1;
                mSetId = res.sets[0].setId;
                mSetMem = res.sets[0].setMem;
                var obj3 = create_item(
                  1,
                  mSetId,
                  mSetName,
                  mSetDesc,
                  mSetCopyNum,
                  mSetMem
                );
                var type1Arr3 = localStorage.getItem("Type1Arr");
                var type2Arr3 = localStorage.getItem("Type2Arr");
                console.log("type1Arr:");
                console.log(type1Arr3);
                if (type1Arr3 == null && type2Arr3 == null) {
                  selectedArr.push(obj3);
                }
                break;
              default:
                break;
            }
            readInfo(this);
          }
          console.log(selectedArr, "587");
          this.selectedArr = selectedArr;
        }
      });
    },
    /**
     * 点击查看详情
     */
    onDetail(item, index) {
      let hosItemsArr = sets[index].hosPrintItems;
      if (item.itemMem !== null) {
        Dialog({
          message: item.itemMem,
        });
      } else {
        let hosItemName = "";
        if (hosItemsArr !== null) {
          // for (let i in hosItemsArr) {
          for (let i = 0; i < hosItemsArr.length; i++) {
            hosItemName =
              hosItemName + "【" + hosItemsArr[i].itemName + "】" + "<br>";
          }
          Dialog({
            message: hosItemName,
          });
        }
      }
    },
    subCopyNum(index) {
      onType1CopiesChange(this, 0, index);
    },
    addCopyNum(index) {
      console.log(selectedArr);
      let itemSum = 0;
      // for (let i in selectedArr) {
      for (let i = 0; i < selectedArr.length; i++) {
        itemSum += selectedArr[i].userSelectCopies;
      }
      if (itemSum >= hosLimitSetCount) {
        Notify({
          type: "warning",
          message: "您选择的套餐总份数超过最大限额" + hosLimitSetCount + "份!",
        });
        return;
      }
      onType1CopiesChange(this, 1, index);
    },
    intoOtherNeed() {
      if (selectedArr.length > 0) {
        console.log(selectedArr, "selectedArr");
        console.log(JSON.stringify(selectedArr), "JSON.stringify(selectedArr)");
        localStorage.setItem("Type1Arr", JSON.stringify(selectedArr));
      } else {
        try {
          localStorage.removeItem("Type1Arr");
        } catch (e) {
          // Do something when catch error
        }
      }
      if (cusArr.length > 0) {
        localStorage.setItem("Type2Arr", JSON.stringify(cusArr));
        localStorage.setItem("Type3Arr", JSON.stringify(cusArr));
      } else {
        try {
          localStorage.removeItem("Type2Arr");
          localStorage.removeItem("Type3Arr");
        } catch (e) {
          // Do something when catch error
        }
      }
      this.$router.push("custom");
    },
    /**
     * 删除选择的套餐
     */
    deletePackage(index) {
      if (index > -1) {
        selectedArr.splice(index, 1);
      }
      this.selectedArr = selectedArr;

      if (selectedArr.length == 0 && cusArr.length == 0) {
        Notify({
          type: "warning",
          message: "请选择需要打印的病历",
        });
        this.isShowDefault = true;
        this.isShowOtherNeed = false;
        this.isShowPackage = false;
        return;
      }
    },
    /**
     * 删除其他需求列表
     */
    deleteOtherList() {
      var tmpArr = new Array();

      for (var index = 0; index < cusArr.length; index++) {
        var item_obj = cusArr[index];
        if (item_obj.mrItemType == 1) {
          tmpArr.push(item_obj);
        }
      }

      cusArr = tmpArr;
      this.cusArr = cusArr;
      localStorage.removeItem("Type2Arr");
      if (cusArr.length == 0) {
        this.isShowOtherNeed = false;
      } else {
        // this.isShowOtherNeed = true;++++++++++++++++++++
        this.isShowOtherNeed = true;
      }

      if (selectedArr.length == 0 && cusArr.length == 0) {
        Notify({
          type: "warning",
          message: "请选择需要打印的病历",
        });
        this.isShowDefault = true;
        this.isShowOtherNeed = false;
        this.isShowPackage = false;
        return;
      }
    },
    /**
     * 点击病理报告选择radio
     */
    clickRadioMr(item) {
      console.log(item);
      if (item.value == "Y") {
        this.isShowRadioWait = true;

        for (let i = 0; i < this.waitRecords.length; i++) {
          let objMedia = this.waitRecords[i];
          let def = objMedia.default;
          // let name = objMedia.name;
          let value = objMedia.value;
          if (def) {
            if (value == "Y") {
              isWaitRecord = "Y";
            } else if (value == "N") {
              isWaitRecord = "N";
            }
          }
        }
      } else if (item.value == "N") {
        this.isShowRadioWait = false;
        isMediaRecord = "N";
        isWaitRecord = "X";
      }
      console.log(isMediaRecord);
      console.log(isWaitRecord);
    },
    /**
     * 等病理选择radio
     */
    clickRadioWait(item) {
      if (item.value == "Y") {
        isWaitRecord = "Y";
      } else if (item.value == "N") {
        isWaitRecord = "N";
      }
      console.log(isMediaRecord);
      console.log(isWaitRecord);
    },
    /**
     * 外伤选择
     */
    clickRadioWaiShang(radio) {
      if (radio == 1) {
        this.wsNeedFlag = "Y";
      } else {
        this.wsNeedFlag = "N";
      }
    },
    //打开浮层
    showTerms() {
      this.isShowTerms = true;
    },
    /**
     * 关闭浮层
     */
    onClosePopup() {
      this.isShowTerms = false;
    },
    /**
     * 提交申请
     */
    submit() {
      let setArr = [];
      // for (let i in selectedArr) {
      for (let i = 0; i < selectedArr.length; i++) {
        let obj = selectedArr[i];
        if (obj.userSelectCopies > 0) {
          setArr.push(obj);
        }
        console.log(setArr, "sssss");
      }
      if (selectUseExpressType.bId != 9) {
        if (setArr.length > 0 || cusArr.length > 0) {
          let jsonArr = createSaveArr(setArr);
          console.log(
            JSON.stringify(jsonArr) + "mmmmmmmmmmmmmmmmmmmmmmmmmmmmmm"
          );
          localStorage.setItem("jsonArr", JSON.stringify(jsonArr));
        } else {
          Notify({
            type: "warning",
            message: "请选择需要打印的病历!",
          });
          return;
        }
      }

      let sumCopy = 0;
      // for (let i in setArr) {
      for (let i = 0; i < setArr.length; i++) {
        sumCopy += setArr[i].userSelectCopies;
      }
      let sumCopy2 = 0;
      if (cusArr.length > 0) {
        sumCopy2 = cusArr[0].userSelectCopies;
      }

      if (sumCopy + sumCopy2 > hosLimitSetCount) {
        Notify({
          type: "warning",
          message: "您选择的套餐总份数超过最大限额" + hosLimitSetCount + "份!",
        });
        return;
      }
      console.log(this.wsNeedFlag);
      if (this.hosWsNeedFlag == 1 && this.$util.isNullString(this.wsNeedFlag)) {
        Notify({
          type: "warning",
          message: "请选择是否属于外伤!",
        });
        return;
      }
      // if (this.agree == false) {
      //   Notify({
      //     type: "warning",
      //     message: "请滑动到底部，阅读并同意相关条款!!",
      //   });
      //   return;
      // }

      let userId = localStorage.getItem("userId");
      let wxId = localStorage.getItem("wxId");
      let userMrId = hosItem.userMrId;
      let inHospitalDate = hosItem.inHospitalDate;
      let outHospitalDate = hosItem.outHospitalDate;
      console.log(inHospitalDate);
      console.log(typeof inHospitalDate);
      let patientName = hosItem.patientName;
      let patientCardId = hosItem.patientCardId;
      let patientCardType = hosItem.patientCardType;
      let patientTelNo = hosItem.patientTelNo;
      let applyMode = 0;
      let proposerName = "";
      let proposerCardId = "";
      let proposerCardType = "";
      let userAddrId = "";
      let receiverName = hosItem.receiverName;
      let receiverTel = hosItem.receiverTel;
      let receiverProvince = hosItem.receiverProvince;
      let receiverCity = hosItem.receiverCity;
      let receiverDistrict = hosItem.receiverDistrict;
      let receiverAddress = hosItem.receiverAddress;
      let selfPickupPlace = hosItem.selfPickupPlace; //自提点
      let printType = selectUseExpressType.bId;
      let chmPageNum = ""; //中草药份数
      let patientHosDep = this.$util.normalString(hosItem.patientHosDep);
      let otherNeedFlag = isWaitRecord + isMediaRecord;
      let requestDesc = filterStr(this.message);
      let printInvoice = hosItem.isPrintInvoice;
      let imageJsonData = JSON.stringify(hosItem.servicePathArr);
      let setJsonData = localStorage.getItem("jsonArr");
      console.log(setJsonData + "ooooooooooooooooooooooooooooooo");
      let patientFlowId = this.$util.normalString(hosItem.patientFlowNo);
      let wsNeedFlag = this.wsNeedFlag;
      let orderTakingPartId = this.$util.normalString(hosItem.expressId);
      let vLibId = hosItem.vLibId;
      let patientHosDepCode = hosItem.patientHosDepCode;
      let params = {
        userId: userId,
        hosId: hosItem.hosId,
        wxId: wxId,
        userMrId: userMrId,
        inHospitalDate: inHospitalDate,
        outHospitalDate: outHospitalDate,
        patientName: patientName,
        patientCardId: patientCardId,
        patientCardType: patientCardType,
        patientTelNo: patientTelNo,
        applyMode: applyMode,
        proposerName: proposerName,
        proposerCardId: proposerCardId,
        proposerCardType: proposerCardType,
        userAddrId: userAddrId,
        receiverName: receiverName,
        receiverTel: receiverTel,
        receiverProvince: receiverProvince,
        receiverCity: receiverCity,
        receiverDistrict: receiverDistrict,
        receiverAddress: receiverAddress,
        selfPickupPlace: selfPickupPlace,
        printType: printType,
        chmPageNum: chmPageNum,
        patientHosDep: patientHosDep,
        otherNeedFlag: otherNeedFlag,
        requestDesc: requestDesc,
        printInvoice: printInvoice,
        imageJsonData: imageJsonData,
        setJsonData: setJsonData,
        patientFlowId: patientFlowId,
        wsNeedFlag: wsNeedFlag,
        orderTakingPartId: orderTakingPartId,
        vLibId: vLibId,
        patientHosDepCode: patientHosDepCode,
      };
      console.log(
        params.setJsonData + "ppppppppppppppppppppppppppppppppppppppp"
      );
      this.disabledSubmit = true;
      this.isLoading = true;
      this.$server.create(params).then((res) => {
        console.log(res);
        if (res.result == 1) {
          localStorage.removeItem("Type1Arr");
          localStorage.removeItem("Type2Arr");
          localStorage.removeItem("Type3Arr");
          // let currentTime = new Date().getTime();
          // localStorage.setItem("localTime", currentTime.toString());
          let requestId = res.requestId;
          let prePayFlag = res.prePayFlag;
          let logparams = {
            userId: localStorage.getItem("userId"),
            phoneV: localStorage.getItem("os"),
            wxV: localStorage.getItem("version"),
            wxId: localStorage.getItem("wxId"),
            pId: 1,
            type: localStorage.getItem("selectTypeLog"),

            // hosId: hosId,
            // bType: selectHbsType.type,
          };
          this.getApplyLog(logparams);
          if (prePayFlag == 1) {
            this.$router.push("/pay/" + requestId + "/" + "1");
          } else {
            this.$router.push("/pay/" + requestId + "/" + "2");
          }
        }
        this.disabledSubmit = false;
        this.isLoading = false;
      });
    },
  },
};

function create_item(itemType, itemId, itemName, itemDesc, copyNum, itemMem) {
  // var obj = {"mrItemName": itemName, "mItemId": itemId, "mItemDesc": itemDesc, "mCopyNum": copyNum}
  var obj = {
    itemType: itemType,
    itemName: itemName,
    itemId: itemId,
    itemDesc: itemDesc,
    userSelectCopies: copyNum,
    itemMem: itemMem,
  };
  return obj;
}

function readInfo(that) {
  //读取数据，展示
  let type1Arr = localStorage.getItem("Type1Arr");
  let type2Arr = localStorage.getItem("Type2Arr");
  // let type3Arr = localStorage.getItem("Type3Arr");
  if (type2Arr != null) {
    let typeArr2 = JSON.parse(type2Arr);
    cusArr = typeArr2;
    that.cusArr = cusArr;
  }
  if (type1Arr != null) {
    let typeArr1 = JSON.parse(type1Arr);
    // for (let index in typeArr1) {
    for (let index = 0; index < typeArr1.length; index++) {
      // for (let i = 0; i <selectedArr.length;i++) {
      let newInfo_obj1 = typeArr1[index];

      if (!hasContainByItemId(newInfo_obj1.itemId)) {
        selectedArr.push(newInfo_obj1);
      }
    }
  }
  if (selectedArr.length == 0 && cusArr.length == 0) {
    that.isShowDefault = true;
    that.isShowOtherNeed = false;
    that.isShowPackage = false;
    return;
  }
}

function hasContainByItemId(itemId) {
  for (let i = 0; i < selectedArr.length; i++) {
    if (selectedArr[i].itemId == itemId) {
      return true;
    }
  }
  return false;
}

function onType1CopiesChange(that, isAdd, index) {
  console.log(index);
  let item_obj = selectedArr[index];
  if (isAdd) {
    //增加

    if (item_obj.userSelectCopies < hosLimitSetCount) {
      item_obj.userSelectCopies++;
      selectedArr.splice(index, 1, item_obj);
    }

    // onReloadArrayObj();
  } else {
    //减少
    if (item_obj.userSelectCopies > 0) {
      item_obj.userSelectCopies--;
      selectedArr.splice(index, 1, item_obj);
    }
  }
  that.selectedArr = selectedArr;
}

function onSelectMrInfo(that, setId, setName, setDesc, setMem) {
  that.isShowDefault = false;
  let mrInfo_obj = null;
  if (hasContainByItemId(setId)) {
    let index = getIndexByItemId(setId, selectedArr);
    mrInfo_obj = selectedArr[index];
    console.log(mrInfo_obj);
    if (
      mrInfo_obj.userSelectCopies < hosLimitSetCount &&
      hosChoiceSet != 3 &&
      hosChoiceSet != 4
    ) {
      mrInfo_obj.userSelectCopies++;
    }
    selectedArr.splice(index, 1, mrInfo_obj);
    console.log(selectedArr);
  } else {
    mrInfo_obj = create_item(1, setId, setName, setDesc, 1, setMem);
    //添加新item
    mSetName = setName;
    mSetDesc = setDesc;
    mSetCopyNum = 1;
    mSetId = setId;

    if (hosChoiceSet == 4) {
      selectedArr = new Array();
    }
    selectedArr.push(mrInfo_obj);
  }
  that.selectedArr = selectedArr;
}

function getIndexByItemId(itemId, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].itemId == itemId) return i;
  }
  return -1;
}

function createSaveArr(setArr) {
  var tempSaveArr = [];
  tempSaveArr.push.apply(tempSaveArr, setArr);
  console.log(setArr, cusArr);
  console.log(cusArr != "");
  console.log(cusArr != null);
  console.log(cusArr != undefined);
  if (cusArr != "") {
    tempSaveArr.push.apply(tempSaveArr, cusArr);
  }
  console.log(tempSaveArr);
  // var jsonArr1 = [];
  // console.log(jsonArr1,'aaaagggggggggggg')
  let cJsonArr = [];

  console.log(cJsonArr, "aaaaaaaaaaaa");
  for (var index = 0; index < tempSaveArr.length; index++) {
    console.log(index);
    var item = tempSaveArr[index];
    console.log(item, "ggggggggggg");
    var obj = {
      itemType: item.itemType,
      itemId: item.itemId,
      itemName: item.itemName,
      userSelectCopies: item.userSelectCopies,
    };
    console.log(obj, "hhhhhhhhhhhhh");
    cJsonArr.push(obj);
  }
  console.log(cJsonArr, "bbbbbbbbbbbbb");
  return cJsonArr;
}

function filterStr(str) {
  if (str == null || str == undefined) {
    return "";
  } else return str.replace(/[\r\n]/g, "");
}
</script>

<style>
.page-content {
  margin-top: 90px;
}

.bg_nodefault {
  text-align: center;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  flex-direction: column;
  height: 300px;
}

.default_v {
  margin: auto;
}

.no_default {
  width: 150px;
  height: 150px;
  align-self: center;
}

.t_nodefault {
  font-size: 15px;
  color: #999;
  margin-top: 10px;
  margin-left: 50px;
  margin-right: 50px;
}

.click_text {
  font-size: 15px;
  color: #14a1fd;
}

.select-btn {
  margin-top: 85px;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  justify-content: center;
}

.btn-print1 {
  font-size: 16px;
  background: #fff;
  padding: 5px 25px 5px 25px;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  justify-content: center;
}

.btn-print2 {
  font-size: 16px;
  background: #fff;
  padding: 5px 25px 5px 25px;
  display: flex;
  display: -webkit-flex;
  /* Safari */
  justify-content: center;
  margin-left: 20px;
}

.otherp {
  width: 20px;
  height: 20px;
}

.print-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  /* padding: 10px 0; */
  margin-top: 2px;
}

.package_tips {
  font-size: 15px;
  margin: 10px;
}

.package_tips_text {
  color: red;
}

.package {
  /* background-image: linear-gradient(90deg, #e2fee2 0%, #f8fcf8 100%); */
  background-color: #fff;
  margin-top: 10px;
  /* border-radius: 5px; */
}

.package-title {
  padding: 10px 16px;
  /*border-bottom: 1px solid #ddd;*/
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  /* height: 15px; */
}

.package-title_left {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  width: 250px;
}

.package-name {
  font-size: 16px;
  color: #1aac19;
  /*width: 150px;*/
  font-weight: bold;
}

.package_del {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  float: right;
}

.detail-view {
  display: -webkit-flex;
  /* Safari */
  display: flex;
  width: 50px;
}

.detail-img {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  display: inline-block;
  align-self: center;
}

.detail-text {
  font-size: 12px;
  color: #eb4c4b;
  margin-left: 2px;
  /*font-weight: bold*/
  display: inline-block;
  align-self: center;
  width: 55px;
}

.select-print {
  padding: 10px 16px;
  /*border-bottom: 1px solid #ddd;*/
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  background-color: white;
  border-radius: 5px;
}

.copynum_deal {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}

.copynum {
  text-align: center;
  width: 80px;
  font-size: 16px;
  color: #1aad19;
}

.other-demand {
  text-align: center;
  margin-top: 10px;
}

.otherDemand-text {
  color: #1aad19;
  display: inline;
}

.other {
  margin-top: 30px;
  /*margin-bottom: 80px;*/
}

.other-item {
  text-align: center;
}

.other-print {
  color: #1aad19;
  text-align: center;
  display: inline;
}

.invoicehintText {
  color: #999;
  font-size: 13px;
  margin-left: 10px;
}

.tv_explain1 {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
  margin-bottom: 5px;
}

.tv_explain2 {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
  margin-bottom: 5px;
}

.tv_select_pathology {
  font-size: 14px;
  width: 60px;
}

.tv_need_pathology {
  font-size: 14px;
  width: 60px;
}

.select-title {
  padding: 10px;
  /*border-bottom: 1px solid #ddd;*/
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  background-color: white;
  border-radius: 5px;
}

.ipt {
  border: none 0;
  outline: medium;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -moz-tap-highlight-color: transparent;
  border-bottom: 1px solid #ccc;
  width: 50px;
  text-align: center;
  font-size: 18px;
}

.package-content_name {
  /*margin-left: 30px;*/
  font-size: 15px;
}

.select-print_name {
  font-size: 16px;
}

.radioName {
  font-size: 13px;
  width: 40px;
}

.delete-logo {
  width: 20px;
  height: 20px;
}

.delete-text {
  font-size: 15px;
  color: #999;
}

.radioView {
  margin-top: 10px;
}

.invoiceView {
  margin-top: 10px;
}

.invoiceText {
  color: #999;
  font-size: 14px;
  margin-left: 10px;
}

.agreeCheckbox {
  display: flex;
  padding: 15px;
  margin-bottom: 80px;
}

.terms {
  font-size: 15px;
  color: #586c94;
}

.message {
  margin-top: 15px;
  margin-bottom: 80rpx;
}

.li-read {
  float: left;
  text-align: left;
  margin: 0px 15px 10px 15px;
  list-style-type: decimal;
  list-style-position: inside;
}
.leavemessage{
  font-size: 20px;
  color: #333333;
  padding: 10px;
  background-color: #efeff4;
}
</style>
